import { render, staticRenderFns } from "./Task_TeacherAskForLeaving.vue?vue&type=template&id=76180bc8&scoped=true&"
import script from "./Task_TeacherAskForLeaving.vue?vue&type=script&lang=js&"
export * from "./Task_TeacherAskForLeaving.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76180bc8",
  null
  
)

export default component.exports